export const getNameInitials = function (fullName) {
  if (fullName === void 0) {
    fullName = '';
  }
  return fullName.split(' ').map(name => name && name[0].toUpperCase()).slice(0, 2).join('');
};